import { render } from "./Inventory_delete_button.vue?vue&type=template&id=3700998d&scoped=true"
import script from "./Inventory_delete_button.vue?vue&type=script&lang=js"
export * from "./Inventory_delete_button.vue?vue&type=script&lang=js"

import "./Inventory_delete_button.vue?vue&type=style&index=0&id=3700998d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3700998d"]])

export default __exports__